"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartupTaskProvider = void 0;
exports.isStartupTask = isStartupTask;
exports.hasStartupTasks = hasStartupTasks;
exports.StartupTaskProvider = Symbol('StartupTaskProvider');
function isStartupTask(arg) {
    if (typeof arg === 'object') {
        if (arg.command !== undefined &&
            typeof arg.command === 'string') {
            return (arg.args === undefined ||
                (arg.args !== undefined &&
                    Array.isArray(arg.args)));
        }
    }
    return false;
}
function hasStartupTasks(arg) {
    if (typeof arg === 'object') {
        return (arg.tasks !== undefined &&
            Array.isArray(arg.tasks) &&
            Boolean(arg.tasks.length) &&
            arg.tasks.every(isStartupTask));
    }
    return false;
}
//# sourceMappingURL=startup-task.js.map